import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

type FormQuestion = {
	text: string;
	type: string;
	isRequired: boolean;
	choices?: string[];
};

type SelectedFormQuestions = {
	title: string;
	description: string;
	questions: FormQuestion[];
};

export type JSMCreateSurveyData = {
	projectId: string;
	portalId: number;
	selectedFormQuestions: SelectedFormQuestions;
};

export type JSMCreateSurveyAction = {
	/**
	 * The unique key identifier for the items creation request.
	 */
	key: string;
	/**
	 * The unique identifier for the action.
	 */
	actionId?: string;
	/**
	 * The unique identifier for the invocation.
	 */
	invocationId: string;
	/**
	 * The current status of the creation process.
	 */
	status?: string;
	/**
	 * The data payload containing the content for the new item.
	 */
	data: JSMCreateSurveyData;
};

/**
 * Properties for the Jira items creation command.
 *
 * @extends CommandProperties
 */
export interface JSMCreateSurveyCommandProperties extends CommandProperties {
	/**
	 * The actions containing the data to create the new items.
	 */
	actions: JSMCreateSurveyAction[];
}

/**
 * A command sent by a bridge API client to create a new Jira items.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Jira items with the specified content.
 */
export const JSMCreateSurveyCommand = createCommand<JSMCreateSurveyCommandProperties>(
	'jsm-create-survey-command',
);
